import React from 'react'
import ModalCloseButton from 'components/modal/components/closeButton'
import ModalIconTile from 'components/modal/components/iconTile'
import 'styles/main.scss'

// The header of company's modals: the title at 24px, the close button a 40px
// square. It keeps its height while the body scrolls (structure.js).
// `description`: the line under the title, 4px below it as in the slide-over
// headers; left in the body, it sat 20px below behind the body's padding.
// `icon`: a pictogram tile above the title, as the company app's confirmations
// (ModalIconTile tone: 'danger', 'warning').
const Modalheader = ({children,hide,hideShow,description,icon}) => {

    return (
        <div className={`flex flex-shrink-0 ${description || icon ? 'items-start' : 'items-center'} justify-between gap-4 px-6 pt-8 rounded-t`}>
            <div className="min-w-0">
                {icon ? <div className="mb-4"><ModalIconTile tone={icon}/></div> : null}
                <h3 className="text-2xl leading-[30px] text-[#202124] font-medium">
                    {children}
                </h3>
                {description && (
                    <p className="mt-1 text-sm text-gray-500">{description}</p>
                )}
            </div>
            {hideShow ?
                <ModalCloseButton onClick={hide} className="ml-auto"/>
                : ''}
        </div>
    )
}

export default Modalheader
